import type { CharterCabinClass } from '~/components/Flights/Charter/charter.types';

export const charterAirportOptions = ['MEL', 'MLE'] as const;

export const charterCabinOptions: Array<{ value: CharterCabinClass; label: string }> = [
  { value: 'economy', label: 'Economy' },
  { value: 'premium_economy', label: 'Premium Economy' },
  { value: 'business', label: 'Business' },
];
